import type { ICartCRUDItem, ProductMMCartFull } from '../models';
import type { IProductEntity } from '@/entities';

import { CartStoreLite, CartStoreFull } from './initCarts';
import { CartLoader } from './CartLoader';

let syncCartPromise: Promise<void> | null = null;

export function useCart() {
  function clearLocalCart() {
    CartStoreFull.reset();
    CartStoreLite.reset();
  }

  /** у CartFull тоже есть этот метод */
  async function syncCart() {
    if (syncCartPromise) return syncCartPromise;

    syncCartPromise = CartStoreLite.syncCart().finally(() => (syncCartPromise = null));

    return syncCartPromise;
  }

  /** Lite Cart */
  const cartQnty = CartStoreLite.qnty;
  const productsLite = CartStoreLite.products;

  const fetchCartLite = async () => CartStoreLite.fetchCart();
  const getProductLiteBySkuId = (skuId: string) => CartStoreLite.getProductBySkuId(skuId);

  function updateProductCartLiteQnty(product: IProductEntity, qnty: number) {
    return CartStoreLite.patchCart([{ product, qnty }]);
  }

  function addProductToCartLite(p: IProductEntity, qnty = 1) {
    return CartStoreLite.addProductToCart(p, qnty);
  }

  /** Full Cart */
  const unavailableProductsFull = CartStoreFull.unavailableProducts;
  const deliveryPrices = CartStoreFull.deliveryPrices;
  const productsFull = CartStoreFull.products as Ref<ProductMMCartFull[]>;
  const summary = CartStoreFull.summary;
  const cartFullConfig = CartStoreFull.config;
  const cartQntyFull = CartStoreFull.qnty;

  async function fetchCartFull() {
    CartLoader.inc();
    return CartStoreFull.fetchCart().finally(() => CartLoader.dec());
  }

  async function patchCartFull(data: ICartCRUDItem[]) {
    CartLoader.inc();
    return CartStoreFull.patchCart(data).finally(() => CartLoader.dec());
  }

  async function addProductToCartFull(p: IProductEntity, qnty = 1) {
    CartLoader.inc();
    return CartStoreFull.addProductToCart(p, qnty).finally(() => CartLoader.dec());
  }

  async function removeUnavailableProducts() {
    CartLoader.inc();
    return CartStoreFull.removeUnavailableProducts().finally(() => CartLoader.dec());
  }

  const setCartCurrentCityId = (cityId: number) => (CartStoreFull.currentCityId = cityId);

  return {
    clearLocalCart,
    syncCart,

    cartQnty,
    productsLite,
    fetchCartLite,
    getProductLiteBySkuId,
    updateProductCartLiteQnty,
    addProductToCartLite,

    unavailableProductsFull,
    productsFull,
    summary,
    deliveryPrices,
    cartQntyFull,
    cartFullConfig,
    fetchCartFull,
    patchCartFull,
    addProductToCartFull,
    removeUnavailableProducts,
    setCartCurrentCityId,

    hasRestrictions: CartStoreFull.hasRestrictions,

    _getTrackerPayload: () => CartStoreFull._trackerPayload,
  };
}
